export type ProjectViewMode = 'kanban' | 'list';
export type DashboardViewMode = 'grid' | 'list';

const GLOBAL_VIEW_MODE_KEY = 'uptimio:projectView';

const normalizeUserId = (userId: string | undefined | null): string | null => {
  if (userId == null || userId === '') return null;
  return String(userId);
};

const viewModeStorageKey = (userId: string) => `uptimio:projectView:${userId}`;

const parseViewMode = (raw: string | null): ProjectViewMode | null => {
  if (raw === 'list' || raw === 'kanban') return raw;
  if (raw === 'grid' || raw === 'board') return 'kanban';
  return null;
};

export const getStoredProjectViewMode = (userId: string | undefined): ProjectViewMode => {
  try {
    const uid = normalizeUserId(userId);
    if (uid) {
      const userScoped = parseViewMode(localStorage.getItem(viewModeStorageKey(uid)));
      if (userScoped) return userScoped;
    }
    const global = parseViewMode(localStorage.getItem(GLOBAL_VIEW_MODE_KEY));
    if (global) return global;
  } catch {
    /* ignore quota / private mode */
  }
  return 'list';
};

export const setStoredProjectViewMode = (userId: string | undefined, mode: ProjectViewMode): void => {
  try {
    localStorage.setItem(GLOBAL_VIEW_MODE_KEY, mode);
    const uid = normalizeUserId(userId);
    if (uid) {
      localStorage.setItem(viewModeStorageKey(uid), mode);
    }
  } catch {
    /* ignore quota / private mode */
  }
};

export const dashboardViewFromMode = (mode: ProjectViewMode): DashboardViewMode =>
  mode === 'kanban' ? 'grid' : 'list';

export const modeFromDashboardView = (view: DashboardViewMode): ProjectViewMode =>
  view === 'grid' ? 'kanban' : 'list';
